import React, { FC, useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import { EnterpriseCardTitle } from '../../../../../enterprise/card/EnterpriseCardTitle';
import { EnterpriseDetails } from '../../../../../enterprise/card/EnterpriseDetails';
import { EntepriseFollowButton } from '../../../../../enterprise/follow-button/EntepriseFollowButton';
import { Spacing } from '../../../../../components/entities-card/Spacing';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { EntitiesCardFooter } from '../../../../../components/entities-card/EntitiesCardFooter';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { EnterpriseSnippetTabs } from './EnterpriseSnippetTabs';
import { Connect, PropsFromRedux } from './EnterpriseSnippetContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { ResultsType } from '../../../../state/reducers/results.types';
import { SnippetActions } from '../SnippetActions';
import { useRestrictedModal } from '../../../../../components/modal/useRestrictedModal';
import { useUser } from '../../../../../user/useUser';
import { Paper } from '../../../../../components/paper/Paper';

type Props = {
  enterprise: NonNullable<ResultsType['snippets']['enterprise']>;
} & PropsFromRedux;

export const RawEnterpriseSnippet: FC<Props> = ({
  originalQueryKey,
  enterprise,
  isFilterToggled,
  toggleLawyerFilter,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  useEffect(() => {
    doctrineAnalytics('Search EnterpriseDisplayed', {
      enterprise_id: enterprise.enterpriseId,
      query_key: originalQueryKey,
    });
  }, []);

  const handleClick = (source: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source });
    }
  };

  const onToggle = () => {
    const value = isFilterToggled ? undefined : enterprise.enterpriseId;
    doctrineAnalytics('Search RestrictEnterpriseClicked', {
      eid: enterprise.enterpriseId,
      restricted: !isFilterToggled,
    });

    toggleLawyerFilter(value);
  };

  return (
    <Paper className="enterprise-snippet">
      <EntitiesCardBody>
        <EnterpriseCardTitle
          onClick={handleClick('search_enterprise_snippet-header')}
          href={
            accessPremium
              ? buildUrlWithParameters(enterprise.url, {
                  original_query_key: originalQueryKey,
                  source: 'search_enterprise_snippet-header',
                })
              : undefined
          }
        >
          {enterprise.raisonSociale}
        </EnterpriseCardTitle>
        <EnterpriseDetails enterprise={enterprise} />
        <Spacing />
        <EntepriseFollowButton
          raisonSociale={enterprise.raisonSociale}
          enterpriseId={enterprise.enterpriseId}
        />
      </EntitiesCardBody>
      <SnippetActions isToggled={isFilterToggled} onToggle={onToggle} />
      <div className="enterprise-snippet__bottom">
        <EnterpriseSnippetTabs
          enterpriseId={enterprise.enterpriseId}
          siren={enterprise.siren}
          raisonSociale={enterprise.raisonSociale}
          url={enterprise.url}
          source="enterprise-snippet"
        />
      </div>
      <EntitiesCardFooter
        onClick={handleClick('search_enterprise_snippet-footer')}
        href={
          accessPremium
            ? `${enterprise.url}?source=search_enterprise_snippet-footer`
            : undefined
        }
      >
        <FormattedMessage id="search/components/search-snippets/aside/enterprise/EnterpriseSnippet.tsx/1" />
      </EntitiesCardFooter>
    </Paper>
  );
};

export const EnterpriseSnippet = Connect(RawEnterpriseSnippet);
